﻿export class AssignComplaint {
    id: number;
    organizationId: number;
    active: boolean;
    statusId: number;
}